import React from 'react';
import ReactTransition from 'react-transition-group/Transition';
import PropTypes from 'prop-types';

const duration = 300;

const defaultStyle = {
  transition: `opacity ${duration}ms ease-in-out`,
  opacity: 0
};

const transitionStyles = {
  entering: { opacity: 0 },
  entered: { opacity: 1 }
};

const Transition = ({ children, ...otherProps }) => (
  <ReactTransition timeout={0} appear in>
    {state => (
      <div style={{ ...defaultStyle, ...transitionStyles[state] }}{...otherProps}>
        {children}
      </div>
    )}
  </ReactTransition>
);

Transition.propTypes = {
  children: PropTypes.node.isRequired
};

export default Transition;
